import { observeImages } from "./_lazy-image";
import { observeNextDepartureElements } from "./_next-departures";

// Destination carousel is a responsive grid (large cards in the first row,
// mini cards below). No slider — just make sure the cards' lazy images and live
// next-departure elements are observed.
function initDestinationCarousel(id) {
	const track = document.querySelector(".destination-carousel-track-" + id);
	if (!track || track.dataset.initialised === "true") {
		return;
	}
	track.dataset.initialised = "true";

	observeImages(track.querySelectorAll("img.lazy"));
	observeNextDepartureElements(track.querySelectorAll(".next-departure-container"));
}

window.initDestinationCarousel = initDestinationCarousel;
